import { Currency, Price } from '@pancakeswap/sdk'
import numeral from 'numeral'

/**
 * Helper to multiply a Price object by an arbitrary amount
 */
export const multiplyPriceByAmount = (
  price: Price<Currency, Currency> | undefined,
  amount: number,
  significantDigits = 18,
) => {
  if (!price) {
    return 0
  }

  try {
    return parseFloat(price.toSignificant(significantDigits)) * amount
  } catch (error) {
    return 0
  }
}

/**
 * Format a token price for display based on its value.
 *
 * Rules:
 * - If price ≥ 1000 → 2 decimal places
 * - If price ≥ 1 and < 1000 → 3 decimal places
 * - If price ≥ 0.0001 and < 1 → 4 decimal places
 * - If price < 0.0001 → 6 decimal places
 *
 * @param price The numeric price value
 * @returns Formatted price string
 */
export function formatPrice(price: number | string | undefined): string {
  if (!price) return '--'

  const p = Number(price)

  if (p >= 1) {
    return numeral(p).format('0,0.00')
  }
  if (p >= 0.001) {
    return numeral(p).format('0,0.000')
  }
  if (p >= 0.00001) {
    return numeral(p).format('0,0.00000')
  }

  return numeral(p).format('0,0.00000000')
}
